<template>
  <span class="custom-icon">
    <i class="icon-checkbox" :class="{ checked: value, disabled: disabled }"></i>
  </span>
</template>

<script>
export default {
  name: 'IconCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
